<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"><h1 class="title"><strong class="b">PREFACE</strong></h1>
<p class="p"><span>This work concerns itself with airports on geographical Long Island—that is, Brooklyn, Queens, Nassau, and Suffolk Counties. The airports are listed alphabetically within each chapter, by their last or most recent name. Any photographs not otherwise credited are from the collection of the Cradle of Aviation Museum. This work briefly covers the history and has photographs of 70 of the 82 airports known to have existed on Long Island since 1909. Sadly, the rest are lost to history.</span></p>
<p class="p-indent"><span>A book of such scope as this could not have been written without the support of many people. When I embarked on this project, I expected that nearly all of the information and photographs could be found in the library and archives of the Cradle of Aviation Museum. Such was not the case; many airfields proved elusive, and pinning down any firm information or finding photographs was difficult. Thus, I called on the support of many individuals and organizations. I could not have completed this project without the following: Lee Roche, Wally Broge, Florence Ogg, Robin Strong, Chuck Webber, Mike Myers, Bob Schmidt, Gene Oshrin, Van Field, Bart Spadaro, Parker Wickham, Barbara Forde, Lou Mancuso, Peter Truesdale, Michael Brosnan, Lynn MacDonald, Walt Winnicki, Leo Polaski, the Port Authority of New York and New Jersey, and the Northrop Grumman History Center.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439632161_fm03.vue?a4af75aa